exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".editable-text-box---2Y8JD {\n  display: block;\n  color: #415667; }\n  .editable-text-box---2Y8JD .label-dim---nlT3h {\n    display: block;\n    width: calc(100% - 10px);\n    padding: 3px;\n    height: 26px;\n    white-space: nowrap;\n    overflow: hidden; }\n  .editable-text-box---2Y8JD .input-dim---2aUfh {\n    display: block;\n    width: calc(100% - 15px);\n    color: #415667; }\n", ""]);

// exports
exports.locals = {
	"editable-text-box": "editable-text-box---2Y8JD",
	"label-dim": "label-dim---nlT3h",
	"input-dim": "input-dim---2aUfh"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[local]---[hash:base64:5]!./~/postcss-loader/lib!./~/sass-loader!./components/editable-text-box/editable-text-box.scss
// module id = pCcr
// module chunks = 1